(() => {
  const expRoot = document.querySelector('[data-az-exp-root]');
  if (expRoot) {
    const cards = [...expRoot.querySelectorAll('[data-az-exp-card]')];
    cards.sort((a,b) => String(b.dataset.date || '').localeCompare(String(a.dataset.date || '')));
    const list = expRoot.querySelector('[data-az-exp-list]');
    cards.forEach(card => list?.appendChild(card));
    expRoot.querySelectorAll('[data-az-exp-filter]').forEach(button => {
      button.addEventListener('click', () => {
        expRoot.querySelectorAll('[data-az-exp-filter]').forEach(b => b.classList.remove('is-active'));
        button.classList.add('is-active');
        const wanted = (button.dataset.azExpFilter || 'all').toLowerCase();
        cards.forEach(card => {
          const status = (card.dataset.status || '').toLowerCase();
          card.hidden = wanted !== 'all' && status !== wanted;
        });
      });
    });
  }

  const anatomyRoot = document.querySelector('[data-az-anatomy-root]');
  if (anatomyRoot) {
    const triggers = [...anatomyRoot.querySelectorAll('[data-az-anatomy-trigger]')];
    const panels = [...anatomyRoot.querySelectorAll('[data-az-anatomy-panel]')];

    const activate = id => {
      triggers.forEach(trigger => {
        const active = trigger.dataset.azAnatomyTrigger === id;
        trigger.classList.toggle('is-active', active);
        trigger.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      panels.forEach(panel => {
        panel.classList.toggle('is-active', panel.dataset.azAnatomyPanel === id);
      });
    };

    triggers.forEach(trigger => trigger.addEventListener('click', () => {
      activate(trigger.dataset.azAnatomyTrigger);
    }));

    if (triggers[0]) activate(triggers[0].dataset.azAnatomyTrigger);
  }
})();
